module.exports = __webpack_public_path__ + "media/images/ball_poster-d3457e9d084acce083302e830b5fa4a3.png";